export default __webpack_public_path__ + "static/media/Selfielocation_college.9dded9d2.png";